module.exports = "<router-outlet ></router-outlet>\n<!--<app-main-spinner></app-main-spinner>-->\n\n"